import { Box, Step, StepButton, Stepper, useTheme, useMediaQuery, Divider, Typography } from "@mui/material";
import { tokens } from "../../theme";
import { ReactNode } from "react";

const ACCENT = "#14b8a6";
const DONE = "#22c55e";

interface StepType {
  stepName: string;
  isCompleted: boolean;
}

interface StickTopStepperProps {
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  steps: StepType[];
  isViewMobile: boolean;
  content?: ReactNode;
}

const StickTopStepper: React.FC<StickTopStepperProps> = ({
  activeStep,
  setActiveStep,
  steps,
  isViewMobile,
  content,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isXsScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleStep = (step: number) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
      event.preventDefault();
      setActiveStep(step);
    };

  return (
    <>
      {!isViewMobile && isXsScreen ? (
        ""
      ) : (
        <Box
          sx={{
            position: "sticky",
            top: 10,
            zIndex: 1100,
            padding: "16px",
            borderRadius: "16px",
            backgroundColor: theme.palette.mode === "dark" ? "#141720" : "#ffffff",
            border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.07)" : "#e5e9ed"}`,
            boxShadow: theme.palette.mode === "dark" ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
          }}
        >
          <Stepper
            nonLinear
            alternativeLabel={!isXsScreen}
            orientation={isXsScreen ? "vertical" : "horizontal"}
            activeStep={activeStep}
            sx={{
              ".MuiSvgIcon-root.Mui-active": {
                color: ACCENT,
                padding: "3px",
                borderRadius: "50%",
                border: 1,
                marginY: "-3px",
              },
              ".MuiStepIcon-text": {
                fontWeight: 600,
                fontSize: 15,
              },
              ".MuiSvgIcon-root.Mui-completed": {
                color: DONE,
              },
              ".MuiStepConnector-line": {
                borderColor: ACCENT,
              },
            }}
          >
            {steps.map(({ stepName, isCompleted }, index) => (
              <Step key={stepName} completed={isCompleted}>
                <StepButton onClick={handleStep(index)}>{stepName}</StepButton>
              </Step>
            ))}
          </Stepper>
          {content && (
            <>
              <Divider sx={{paddingTop : 1}}/>
              {content}
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default StickTopStepper;
